import instance from "../api-provider";

export const checkIsCheckedIn = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "/isCheckedIn",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {}
};

export const handleClockIn = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "/handleClockIn",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    return "something";
  }
};

export const getUsers = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "/superadmin/getUsers",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    console.log("error getUsers: ", error);
  }
};

export const searchUsers = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "/superadmin/searchUsers",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    console.log("error searchUsers: ", error);
  }
};

export const addPracticesToUser = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "/superadmin/addPracticesToUser",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    console.log("error addPracticesToUser: ", error);
  }
};

export const removePracticesFromUser = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "/superadmin/removePracticesFromUser",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    console.log("error removePracticesFromUser: ", error);
  }
};

export const addAccessToUser = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "/superadmin/addAccessToUser",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    console.log("error addAccessToUser: ", error);
  }
};

export const removeAccessFromUser = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "/superadmin/removeAccessFromUser",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    console.log("error removeAccessFromUser: ", error);
  }
};

export const updateScribeProviderAccess = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "/superadmin/updateScribeProviderAccess",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    console.log("error updateScribeProviderAccess: ", error);
    throw error;
  }
};

export const checkUserExists = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "/superadmin/checkUserExists",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    console.log("error checkUserExists: ", error);
  }
};

export const addUser = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "/superadmin/addUser",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    console.log("error addUser: ", error);
  }
};

export const applyLeave = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "/applyLeave",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {}
};

export const addTask = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "/addTask",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {}
};

export const getUsersLoggedData = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "/getUsersLoggedData",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {}
};

export const getUsersTasks = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "/getUsersTasks",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {}
};

export const getUsersLeaves = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "/getUsersLeaves",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {}
};
